// extracted by mini-css-extract-plugin
export default {"socialContainer":"media_socialContainer__zIrPr","line":"media_line__egMSX"};